import { useQuery } from "@tanstack/react-query";
import { getTeacher } from "../../api/apiTeachers";
import i18next from "i18next";

export function useGetTeacher(id) {
    const { isLoading, data: teacher, error } = useQuery({
        queryKey: ["teachers", id, i18next.language],
        queryFn: () => getTeacher(id),
        enabled: !!id,
        retry: false,
    });
    return { isLoading, error, teacher };
}
